export type AccountTab = 'settings' | 'owner' | 'password' | 'experience' | 'availability';

export const DEFAULT_ACCOUNT_TAB: AccountTab = 'settings';

export function parseAccountTab(value: string | null | undefined): AccountTab {
  if (value === 'experience' || value === 'owner' || value === 'password' || value === 'availability') return value;
  return DEFAULT_ACCOUNT_TAB;
}

export function buildAccountLink(tab: AccountTab = DEFAULT_ACCOUNT_TAB): string {
  if (tab === DEFAULT_ACCOUNT_TAB) return '/account';
  return `/account?tab=${tab}`;
}
